import {Injectable} from '@angular/core';
import {MatPaginatorIntl} from '@angular/material/paginator';
import {
  getMaterialPaginatorRangeLabel,
  MATERIAL_PAGINATOR_LABELS
} from '../models/shared/material-paginator-labels.model';
import {AppLanguage} from '../models/shared/app-language.model';

@Injectable()
export class AppMaterialPaginatorIntl extends MatPaginatorIntl {
  private readonly language: AppLanguage = 'mk';

  constructor() {
    super();
    const labels = MATERIAL_PAGINATOR_LABELS[this.language];

    this.firstPageLabel = labels.firstPageLabel;
    this.itemsPerPageLabel = labels.itemsPerPageLabel;
    this.lastPageLabel = labels.lastPageLabel;
    this.nextPageLabel = labels.nextPageLabel;
    this.previousPageLabel = labels.previousPageLabel;
  }

  override getRangeLabel = (page: number, pageSize: number, length: number): string => {
    return getMaterialPaginatorRangeLabel(page, pageSize, length, this.language);
  };
}
